module.exports = __webpack_public_path__ + "static/img/top.41ada94a.png";